import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';

import { Account } from '@accounts/models/account';
import { AccountDisplayNamePipe } from '@accounts/pipes/account-display-name.pipe';

@Component({
  selector: 'app-account-signature',
  standalone: true,
  imports: [MatIcon, MatTooltip, AccountDisplayNamePipe],
  templateUrl: './account-signature.component.html',
  styleUrls: ['./account-signature.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AccountSignatureComponent {
  readonly account = input.required<Account>();
  readonly onlyAvatar = input<boolean>(true);
  readonly displayTooltip = input<boolean>(false);
}
